export default __webpack_public_path__ + "static/media/logo20211.168e90f2.svg";